import { ISvgProps } from '@src/types';

const CalculatorStopIcon = ({
  width = '32px',
  height = '37px',
  fillColor = 'var(--font-color)',
  ...props
}: ISvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={{ marginTop: '3px' }}
      viewBox="0 0 30 30"
    >
      <path
        fill="#6C1C88"
        transform="translate(0.157996 0.154822)"
        d="M9.2073946 0L17.898487 0C22.983591 -1.7763568e-15 27.105883 4.1222911 27.105883 9.2073946L27.105883 17.898487C27.105883 22.983591 22.983591 27.105883 17.898487 27.105883L9.2073946 27.105883C4.1222911 27.105883 0 22.983591 0 17.898487L0 9.2073946C0 4.1222911 4.1222911 0 9.2073946 0Z"
        fillRule="evenodd"
      />
      <path
        fill="none"
        stroke="#42444C"
        strokeWidth="0.30978152"
        strokeMiterlimit="10"
        transform="translate(0.157996 0.154822)"
        d="M9.2073946 0L17.898487 0C22.983591 -1.7763568e-15 27.105883 4.1222911 27.105883 9.2073946L27.105883 17.898487C27.105883 22.983591 22.983591 27.105883 17.898487 27.105883L9.2073946 27.105883C4.1222911 27.105883 0 22.983591 0 17.898487L0 9.2073946C0 4.1222911 4.1222911 0 9.2073946 0Z"
        fillRule="evenodd"
      />

      <path
        fill="white"
        transform="translate(7.41094 7.80776)"
        d="M1.125 6.0250001L4.9000001 6.0250001C5.52035 6.0250001 6.0250001 5.52035 6.0250001 4.9000001L6.0250001 1.125C6.0250001 0.50465 5.52035 0 4.9000001 0L1.125 0C0.50465 0 0 0.50465 0 1.125L0 4.9000001C0 5.52035 0.50465 6.0250001 1.125 6.0250001ZM1.9 2.6500001L2.6500001 2.6500001L2.6500001 1.9C2.6500001 1.6927249 2.8177249 1.525 3.0250001 1.525C3.232275 1.525 3.4000001 1.6927249 3.4000001 1.9L3.4000001 2.6500001L4.1500001 2.6500001C4.357275 2.6500001 4.5250001 2.8177249 4.5250001 3.0250001C4.5250001 3.232275 4.357275 3.4000001 4.1500001 3.4000001L3.4000001 3.4000001L3.4000001 4.1500001C3.4000001 4.357275 3.232275 4.5250001 3.0250001 4.5250001C2.8177249 4.5250001 2.6500001 4.357275 2.6500001 4.1500001L2.6500001 3.4000001L1.9 3.4000001C1.6927249 3.4000001 1.525 3.232275 1.525 3.0250001C1.525 2.8177249 1.6927249 2.6500001 1.9 2.6500001Z"
      />
      <path
        fill="white"
        transform="translate(14.1859 7.80776)"
        d="M4.9000001 0L1.125 0C0.50465 0 0 0.50465 0 1.125L0 4.9000001C0 5.52035 0.50465 6.0250001 1.125 6.0250001L4.9000001 6.0250001C5.52035 6.0250001 6.0250001 5.52035 6.0250001 4.9000001L6.0250001 1.125C6.0250001 0.50465 5.52035 0 4.9000001 0ZM4.1500001 3.4000001L1.875 3.4000001C1.667725 3.4000001 1.5 3.232275 1.5 3.0250001C1.5 2.8177249 1.667725 2.6500001 1.875 2.6500001L4.1500001 2.6500001C4.357275 2.6500001 4.5250001 2.8177249 4.5250001 3.0250001C4.5250001 3.232275 4.357275 3.4000001 4.1500001 3.4000001Z"
      />
      <path
        fill="white"
        transform="translate(14.1859 14.5828)"
        d="M4.9000001 0L1.125 0C0.50465 0 0 0.50465 0 1.125L0 4.9000001C0 5.52035 0.50465 6.0250001 1.125 6.0250001L4.9000001 6.0250001C5.52035 6.0250001 6.0250001 5.52035 6.0250001 4.9000001L6.0250001 1.125C6.0250001 0.50465 5.52035 0 4.9000001 0ZM4.1500001 4.125L1.875 4.125C1.667725 4.125 1.5 3.9572749 1.5 3.75C1.5 3.5427251 1.667725 3.375 1.875 3.375L4.1500001 3.375C4.357275 3.375 4.5250001 3.5427251 4.5250001 3.75C4.5250001 3.9572749 4.357275 4.125 4.1500001 4.125ZM4.1500001 2.625L1.875 2.625C1.667725 2.625 1.5 2.4572749 1.5 2.25C1.5 2.0427251 1.667725 1.875 1.875 1.875L4.1500001 1.875C4.357275 1.875 4.5250001 2.0427251 4.5250001 2.25C4.5250001 2.4572749 4.357275 2.625 4.1500001 2.625Z"
      />
      <path
        fill="white"
        transform="translate(7.41094 14.5828)"
        d="M6.0250001 4.9000001L6.0250001 1.125C6.0250001 0.50465 5.52035 0 4.9000001 0L1.125 0C0.50465 0 0 0.50465 0 1.125L0 4.9000001C0 5.52035 0.50465 6.0250001 1.125 6.0250001L4.9000001 6.0250001C5.52035 6.0250001 6.0250001 5.52035 6.0250001 4.9000001ZM4.0855498 3.5302751C4.2320251 3.6767499 4.2320251 3.9140749 4.0855498 4.0605502C3.939075 4.2070251 3.70175 4.2070251 3.555275 4.0605502L3.0250001 3.5302751L2.494725 4.0605502C2.3482499 4.2070251 2.110925 4.2070251 1.96445 4.0605502C1.817975 3.9140749 1.817975 3.6767499 1.96445 3.5302751L2.494725 3L1.96445 2.4697249C1.817975 2.3232501 1.817975 2.0859251 1.96445 1.93945C2.110925 1.7929749 2.3482499 1.7929749 2.494725 1.93945L3.0250001 2.4697249L3.555275 1.93945C3.70175 1.7929749 3.939075 1.7929749 4.0855498 1.93945C4.2320251 2.0859251 4.2320251 2.3232501 4.0855498 2.4697249L3.555275 3L4.0855498 3.5302751Z"
      />
    </svg>
  );
};

export default CalculatorStopIcon;
